import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconBookmark } from "@arco-design/web-vue/es/icon";
const routes: AppRouteRecordRaw = {
  path: '/evaluation-resource',
  redirect: '/evaluation-resource/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '评价资源',
    icon: IconBookmark,
    // hideChildrenInMenu: true,
    order: 300,
    roles: ['authorized-org-admin', 'admin'],
    // roles: ['system-admin', 'admin'],
  },
  children: [
    {
      path: 'hot-item',
      component: () => import('@/views/evaluation-resource/hot-item.vue'),
      meta: {
        title: '热门项目',
      },
    },
    {
      path: 'index',
      component: () => import('@/views/evaluation-resource/index.vue'),
      meta: {
        title: '重点项目管理',
      },
    },
    {
      path: 'add-key-project/:id?',
      props: true,
      component: () => import('@/views/evaluation-resource/components/project/add-key-project.vue'),
      meta: {
        title: '新增重点项目',
        hideInMenu: true,
        activeMenu: '/evaluation-resource/index',
      },
    },

    {
      path: 'project-detalils/:id?/:type?',
      component: () => import('@/views/evaluation-resource/components/project/project-detalils.vue'),
      props: true,
      meta: {
        title: '项目详情',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/evaluation-resource/index',
      },
    },

    // {
    //   path: 'emplate-market',
    //   component: () => import('@/views/evaluation-resource/emplate-market.vue'),
    //   meta: {
    //     title: '权重模板市场',
    //   },
    // },
    // {
    //   path: 'publishing-template/:id?',
    //   props: true,
    //   component: () => import('@/views/evaluation-resource/components/emplate-market/publishing-template.vue'),
    //   meta: {
    //     title: '发布模板',
    //     hideInMenu: true,
    //   },
    // },
    {
      path: 'weight-template',
      component: () => import('@/views/evaluation-resource/weight-template.vue'),
      meta: {
        title: '权重模板管理',
      },
    },
    // {
    //   path: 'add-edit-weight',
    //   component: () => import('@/views/evaluation-resource/components/weight/add-edit-weight.vue'),
    //   meta: {
    //     title: '新增权重',
    //     hideInMenu: true,
    //     ignoreCache: true,
    //     noAffix: true,
    //     activeMenu: '/evaluation-resource/weight-template',
    //   },
    // },
    // {
    //   path: 'add-edit-weight/:id?/:type?',
    //   component: () => import('@/views/evaluation-resource/components/weight/add-edit-weight.vue'),
    //   props: true,
    //   meta: {
    //     title: '编辑权重',
    //     hideInMenu: true,
    //     ignoreCache: true,
    //     noAffix: true,
    //     activeMenu: '/evaluation-resource/weight-template',
    //   },
    // },
    {
      path: 'add-edit-weight/:id?/:type?',
      component: () => import('@/views/evaluation-resource/components/weight/add-edit-weights.vue'),
      props: true,
      meta: {
        title: '编辑权重',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/evaluation-resource/weight-template',
      },
    },
    {
      path: 'custom-data',
      component: () => import('@/views/evaluation-resource/custom-data.vue'),
      meta: {
        hideInMenu: true,
        title: '自定义数据管理',
      },
    },

    {
      path: 'customs-details/:id',
      component: () => import('@/views/evaluation-resource/components/custom/customs-details.vue'),
      props: true,
      meta: {
        title: '自定义数据详情',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/evaluation-resource/custom-data',
      },
    },

    {
      path: 'upload-file',
      component: () => import('@/views/evaluation-resource/components/custom/upload-file.vue'),
      meta: {
        title: '上传文件',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/evaluation-resource/custom-data',
      },
    },
    {
      path: 'file-details/:id',
      component: () => import('@/views/talent-evaluation/components/index/push-excle.vue'),
      meta: {
        title: '文件详情',
        hideInMenu: true,
        ignoreCache: true,
        noAffix: true,
        activeMenu: '/evaluation-resource/custom-data',
      },
    },
  ],
};

export default routes;
